import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { Cart } from '../../../core/interfaces/cart.interface';
import { FormGroup } from '@angular/forms';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { Image } from '@progress/kendo-drawing';
import { ItemImageSearchResult } from '../../../shared/interfaces/gridrows/item-image-search-result.interface';
import { ImageEntity } from "../../../shared/interfaces/entities/image.interface";

@Injectable({
  providedIn: 'root'
})

export class CheckoutService {
  constructor(private http: HttpClient,
    private urlHelper: UrlHelperService) {

    //public state: State = { skip: 0, take: 100 };
  }

  lookupState(countryId: number): any {
    var url = this.urlHelper.getApiUrl() + "State?countryId=" + countryId;
    return this.http.get(url);
  }
}
